import { Loading } from "../../Components/Loading"
import { TimelineFade } from "../../Components/TimelineFade"
import { IDay } from "../../Types"
import { CruiseView } from "../CruiseView"
import { DayView } from "../DayView"
import { TripView } from "../TripView"
import { FocusConfirmationDialogView } from "./ConfirmationDialogView"
import { FocusSubscriptionWarningView } from "./SubscriptionWarningView"
import { FocusContentViewProps } from "./Params"

// The focus content tree: given the root's loaded/derived state, render the
// Cruise -> Trip -> Day composition (or a Loading placeholder). Nothing is rendered while
// a ship overlay is open. The init/demo branch primes the same tree from seed props.
export function FocusContentView({
  confirmationType,
  completeConfirmation,
  shipOverlayActive,
  currentState,
  currentCruise,
  currentLog,
  currentLogView,
  dayUserAdvices,
  navigationStarted,
  dayYesterday,
  dayToday,
  dayTodayActive,
  dayTomorrow,
  previousDay,
  initCruise,
  initTrip,
  initDay,
  initDayTab,
  initDayTomorrow,
  initDayTomorrowDetails,
  initLogHighlight,
  initLogTabs,
  initLogs,
  initStatuses,
}: FocusContentViewProps) {
  if (shipOverlayActive) {
    return null;
  }

  if (confirmationType && initTrip && initCruise) {
    // Show TripEditView immediately with init data when starting a trip
    const days = [initDay, initDayTomorrow].filter(Boolean) as IDay[];
    return (
      <>
        <CruiseView cruiseId={initCruise.id} initialCruise={initCruise} focus={true}>
          <TimelineFade before={true} count={8} width={18} />
          <TripView trip={initTrip} currentDays={days} focus={true} overrideDays={days}>
            {initDay && (() => {
              return <DayView day={initDay} currentLog={currentLog} currentLogView={currentLogView} focus={true} hideTimeline={!navigationStarted} isCurrentDay={true} isFirstTripDay={true} initDetails={true} initHighlight={initLogHighlight} initLogTabs={initLogTabs} initLogs={initLogs !== undefined ? initLogs : []} initStatuses={initStatuses || []} initTab={initDayTab ?? "day"} />;
            })()}

            {initDayTomorrow && <DayView day={initDayTomorrow} focus={true} isTomorrow={true} initDetails={initDayTomorrowDetails || false} initSelected={initDayTomorrowDetails || false} />}
          </TripView>
          <TimelineFade before={false} width={18} />
        </CruiseView>
      </>
    );
  }

  if (!currentState || !currentCruise || !currentState?.trip) {
    return <Loading />;
  }

  return (
    <>
      {confirmationType && <FocusConfirmationDialogView complete={completeConfirmation} confirmationType={confirmationType} />}
      <CruiseView cruiseId={currentCruise.id} initialCruise={currentCruise} focus={true} storeBacked>
        <TimelineFade before={true} count={8} width={18} />
        {currentState.trip ? (
          <TripView trip={currentState.trip} currentDays={currentState.days} focus={true} overrideDays={currentState.days} storeBacked>

            {dayYesterday && <DayView day={dayYesterday} focus={true} isYesterday={true} />}

            {dayToday && <DayView advices={dayUserAdvices} day={dayToday} currentLog={currentLog} currentLogView={currentLogView} focus={true} hideTimeline={!navigationStarted && !dayTodayActive} initLogs={currentState.logs} initStatuses={currentState.statuses} isCurrentDay={true} isFirstTripDay={currentState.firstDay} provisionalLogs={currentState.provisionalLogs} initDetails={initDayTab !== undefined ? true : undefined} initTab={initDayTab} />}

            <FocusSubscriptionWarningView currentState={currentState} />

            {dayTomorrow && (
              <>
                <DayView day={dayTomorrow} focus={true} isTomorrow={true} initDetails={initDayTomorrowDetails || false} initSelected={initDayTomorrowDetails || false} previousDay={previousDay} />
              </>
            )}
          </TripView>
        ) : <Loading />}
        <TimelineFade before={false} width={18} />
      </CruiseView>
    </>
  );
}
